module.exports = __webpack_public_path__ + "img/image20.80d30880.jpeg";